import React from 'react'
import PageHeader from "../../../../components/PageHeader";
import Sidebar from "../../../../components/Sidebar";
import 'react-tabs/style/react-tabs.css';
import GradeManager, {GRADE_CONST} from "../../../../components/Grade";
import {getSchoolYear} from "../../../../utils/authority";
import ClassRoomController from "../../../../services/data-declaration/class-room-controller";
import {toast} from "react-toastify";
import ModalCreateLatePickUpCheck from "./modalCreateLatePickUpCheck";
import LatePickUpCheckController from "../../../../services/system/late-pick-up-check/late-pick-up-check-controller";

export const Month = [
    {
        "id": 1,
        "name": "Tháng 1"
    },
    {
        "id": 2,
        "name": "Tháng 2"
    },
    {
        "id": 3,
        "name": "Tháng 3"
    },
    {
        "id": 4,
        "name": "Tháng 4"
    },
    {
        "id": 5,
        "name": "Tháng 5"
    },
    {
        "id": 6,
        "name": "Tháng 6"
    },
    {
        "id": 7,
        "name": "Tháng 7"
    },
    {
        "id": 8,
        "name": "Tháng 8"
    },
    {
        "id": 9,
        "name": "Tháng 9"
    },
    {
        "id": 10,
        "name": "Tháng 10"
    },
    {
        "id": 11,
        "name": "Tháng 11"
    },
    {
        "id": 12,
        "name": "Tháng 12"
    }
]

class AttendanceLatePickUpManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listData: [],
            listClass: [],
            pageNumber: 0,
            pageSize: 10,
            classRoomId: -1,
            gradeId: "",
            month: -1,
            fromDay: 0,
            listDayInMonth: [],
            toDay: -1,
            year: -1,
            isShowText: false,
            sort: 'id',
            descending: 'DESC',
            totalItem: 0,
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Họ và tên",
                    style: {textAlign: "left"},
                    sort: false
                }
            ]
        }
    }
    componentWillMount() {
        const d = new Date();
        let year = d.getFullYear();
        let month = d.getMonth()+1;
        let dayOfMonth = d.getDate();

        this.setState({
            year: year,
            month: month,
            fromDay: dayOfMonth,
            toDay: dayOfMonth,
            listDayInMonth: this.getListInMonth(year, month),
        },()=>{
            this.getListHeader()
        });
    }
    getListInMonth(year, month){
        return this.range(1, this.getDaysInMonth(year, month, 0))
    }
    getListHeader(){
        let listHeader = [
            {
                id: "123",
                name: "STT",
                style: {textAlign: "center"},
                sort: false
            },
            {
                id: "name",
                name: "Họ và tên",
                style: {textAlign: "center"},
                sort: false
            }
        ]

        for(let i=parseInt(this.state.fromDay); i <= parseInt(this.state.toDay); i++){
            listHeader.push({
                id: "dd"+i,
                name: i,
                style: {textAlign: "center"},
                sort: false
            })
        }
        this.setState({
            header: listHeader
        });
    }
    range(start, end) {
        var foo = [];
        for (var i = start; i <= end; i++) {
            foo.push(i);
        }
        return foo;
    }
    getDaysInMonth(year, month) {
        return new Date(year, month, 0).getDate();
    }
    getDaysOfWeek(year, month, day){
        return new Date(year, month-1, day).getDay();
    }
    getListDiemDanh() {
        this.getListHeader()
        if (this.state.classRoomId < 0){
            toast.warning("Vui lòng chọn lớp học", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else  if (this.state.month < 0 || this.state.fromDay < 0 || this.state.toDay < 0){
            toast.warning("Vui lòng chọn Ngày/Tháng", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else {
            let payload = {
                "classId": parseInt(this.state.classRoomId),
                "fromDay": parseInt(this.state.fromDay),
                "month": parseInt(this.state.month),
                "toDay": parseInt(this.state.toDay),
                "year": parseInt(this.state.year)
            };
            LatePickUpCheckController.list(payload, res => {
                this.setState({
                    showLoading: false,
                    listData: res.data
                });
            })
        }


    }
    getListClass = () => {
        let payload = {
            name: "",
            grade: this.state.gradeId,
            yearId: parseInt(getSchoolYear()),
            pageNumber: 0,
            pageSize: 500,
            "sort": "created_at desc"
        };
        ClassRoomController.search(payload, res => {
            this.setState({
                listClass: res.data.content
            });
        })
    };
    onUpdateGrade(gradeId){
        this.setState({
            gradeId: gradeId
        }, ()=>{
            this.getListClass()
        });
    }
    getClassName(name, grade){
        return "["+GRADE_CONST[grade]+"] "+name
    }
    renderClass() {
        return this.state.listClass.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    renderMonth() {
        return Month.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    renderDays() {
        return this.state.listDayInMonth.map((item, index) => <option
            value={item}>{item}</option>)
    }
    renderContent(row, index){
        let listContent = [
            <td style={{textAlign: "center"}} scope="row">
                {" "}
                {this.state.pageNumber * this.state.pageSize +
                index +
                1}
            </td>,
            <td style={{textAlign: "center"}} scope="row">
                {" "}
                {row.fullName}
            </td>
        ]
        let dateObj = new Date();
        let month = dateObj.getUTCMonth() + 1; //months from 1-12
        let day = dateObj.getUTCDate();
        let year = dateObj.getUTCFullYear();
        row.latePickUpDays.forEach(dayObj => {
            if (this.getDaysOfWeek(this.state.year, this.state.month, dayObj.day) === 0){
                listContent.push(
                    <td style={{textAlign: "center", background: "#0bff00"}} scope="row">
                        <div>CN</div>
                    </td>
                )
            }else if (this.getDaysOfWeek(this.state.year, this.state.month, dayObj.day) > 0 && this.getDaysOfWeek(this.state.year, this.state.month, dayObj.day) < 6){
                listContent.push(
                    <td style={{textAlign: "center", background: "#fff"}} scope="row">

                        {dayObj.latePickUp != null && <button className="btn btn-action p-2"
                                                           title='Chi tiết'
                                                           style={{cursor: 'pointer', background: "#ff0000", color: "#fff"}}
                                                           onClick={() => {
                                                               this.setState({studentId: row.id, day: dayObj.day, showModalCreate: true})
                                                           }}
                        >

                            M
                        </button>}
                        {dayObj.latePickUp == null && day === dayObj.day && month === this.state.month && year === this.state.year && <button className="btn btn-action p-2"
                                                                                                                                                  title='Chi tiết'
                                                                                                                                                  style={{cursor: 'pointer', background: "#0700ff", color: "#fff"}}
                                                                                                                                                  onClick={() => {
                                                               this.setState({studentId: row.id, day: dayObj.day, showModalCreate: true})
                                                           }}
                        >

                            Đón
                        </button>}

                    </td>
                )
            }else {
                listContent.push(
                    <td style={{textAlign: "center", background: "#dcff00"}} scope="row">
                        <div>Thứ 7</div>
                    </td>
                )
            }

        });
        return (
            listContent
        )
    }
    renderHeader(){
        return this.state.header.map((obj, i) => {
            obj.style = {
                ...obj.style,
                backgroundColor: '#c6e6f1',
                color: 'black',
                verticalAlign: "middle",
                minWidth: obj.style.minWidth ? obj.style.minWidth : '60px',
                fontWeight: 'normal'
            };
            return (
                <th style={obj.style}
                    scope="col" onClick={() => {
                    if (obj.sort) this.clickSort(obj, i)
                }}>
                    <div className="d-flex justify-content-center">
                        <div>
                            <a style={{color: 'black'}}>{obj.name}</a>
                        </div>
                        {obj.sort &&
                        <div style={{verticalAlign: "middle"}}>
                            <i style={{color: this.hoverColor(obj, i), cursor: "pointer", marginLeft: 3}} className={this.ascendingStyle(obj)}/>
                        </div>}
                    </div>
                </th>
            )
        })
    }
    render() {
        let {gradeId, isShowText, listData, header} = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="late-pick-up" parentClass="late-pick-up-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            {this.state.showLoading &&
                            <div className="content-loading col-12 ml-3 align-items-center"
                                 style={{display: 'block'}}>
                                <div className="spinner-grow text-info"/>
                            </div>
                            }
                            <div className="card col-12">
                                <div className="pt-3 mb-2">
                                    <PageHeader routerEnable={true} title="Điểm danh đón muộn"/>
                                    <form className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <div className="row">
                                            <div className='col-md-4 col-sm-12 p-0 pr-3 d-flex'>
                                                <label className="col-4 label-item pl-0" style={{textAlign: "end"}}>Khối</label>
                                                <GradeManager
                                                    isShowText={isShowText}
                                                    gradeId={gradeId}
                                                    onUpdateGrade={(gradeId) => this.onUpdateGrade(gradeId)}
                                                />
                                            </div>

                                            <div className='col-md-4 col-sm-12 p-0 pr-3 d-flex'>
                                                <label className="label-item col-md-3" style={{textAlign: "end"}}>Tháng</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.month}
                                                    onChange={(e) => {
                                                        this.state.month = parseInt(e.target.value);
                                                        this.setState({
                                                            month: e.target.value,
                                                            listDayInMonth: this.getListInMonth(this.state.year, this.state.month)
                                                        }, () =>{
                                                            this.getListDiemDanh()
                                                        });
                                                    }}
                                                >
                                                    <option value="">Chọn tháng</option>
                                                    {this.renderMonth()}
                                                </select>
                                            </div>
                                            <div className='col-md-4 col-sm-12 p-0 pr-3 d-flex'></div>
                                            <div className='col-md-4 col-sm-12 p-0 pr-3 d-flex mt-2'>
                                                <label className="col-4 label-item pl-0" style={{textAlign: "end"}}>Lớp</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.classRoomId}
                                                    onChange={(e) => {
                                                        if (e.target.value != ""){
                                                            this.state.classRoomId = parseInt(e.target.value);
                                                            this.setState({
                                                                classRoomId: e.target.value
                                                            }, ()=>{
                                                                this.getListDiemDanh()
                                                            })
                                                        }
                                                    }}
                                                >
                                                    <option value="">Chọn lớp</option>
                                                    {this.renderClass()}
                                                </select>
                                            </div>
                                            <div className='col-md-2 col-sm-12 p-0 pr-3 d-flex mt-2'>
                                                <label className="col-4 label-item pl-0" style={{textAlign: "end"}}>Từ</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.fromDay}
                                                    onChange={(e) => {
                                                        if (e.target.value != ""){
                                                            this.state.fromDay = parseInt(e.target.value);
                                                            this.setState({
                                                                fromDay: e.target.value
                                                            }, ()=>{
                                                                this.getListDiemDanh()
                                                            })
                                                        }
                                                    }}
                                                >
                                                    <option value="">Chọn ngày</option>
                                                    {this.renderDays()}
                                                </select>
                                            </div>
                                            <div className='col-md-3 col-sm-12 p-0 pr-3 d-flex mt-2'>
                                                <label className="col-4 label-item pl-0" style={{textAlign: "end"}}>Tới</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.toDay}
                                                    onChange={(e) => {
                                                        if (e.target.value != ""){
                                                            this.state.toDay = parseInt(e.target.value);
                                                            this.setState({
                                                                toDay: e.target.value
                                                            }, ()=>{
                                                                this.getListDiemDanh()
                                                            })
                                                        }
                                                    }}
                                                >
                                                    <option value="">Chọn ngày</option>
                                                    {this.renderDays()}
                                                </select>
                                            </div>

                                            <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex mt-3"
                                                 style={{
                                                     alignItems: "center",
                                                     justifyContent: "right"
                                                 }}>
                                                <label>M: Đón muộn. Ấn Đón để thiết lập giờ đón muộn!</label>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="p-0 mb-3">
                                    <div className="table-wrapper">
                                        <table
                                            className="table table-striped table-data table-responsive table-bordered">
                                            <table className="table">
                                                <thead>
                                                <tr>
                                                    {this.renderHeader()}
                                                </tr>
                                                </thead>
                                                {!this.state.listData ||
                                                this.state.listData.length == 0 ? (
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan={this.state.header.length}>
                                                            <div className="text-center">
                                                                Không có dữ liệu
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                    {listData &&
                                                    listData.length > 0 &&
                                                    listData?.map((row, index) => (
                                                        <tr style={{height: 50}}>
                                                            {this.renderContent(row, index)}
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                )}
                                            </table>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalCreateLatePickUpCheck
                    show={this.state.showModalCreate}
                    onHide={() => this.setState({showModalCreate: false})}
                    onRefresh={() => this.getListDiemDanh()}
                    id={this.state.studentId}
                    day={this.state.day}
                    month={this.state.month}
                    year={this.state.year}
                    classRoomId={this.state.classRoomId}
                />
            </div>
        )
    }
}

export default AttendanceLatePickUpManagement
